import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import SideBar from './components/SideBar';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import API from './services/AplicationService';
import { LoadPanel } from 'devextreme-react/load-panel';
import { Link } from 'react-router-dom';
import { handleError, formatNumberDecimalPlaces } from './utils/Utility';
import DataGrid from 'devextreme-react/data-grid';
const initialState = {
	showLoadingPanel: false,
	dashboard: {},
};
class App extends React.Component {
	state = initialState;
	constructor(props) {
		super(props);
		this.setState({ showLoadingPanel: false, dashboard: {} });
	}
	componentDidMount() {
		this.setState({ ...this.state, showLoadingPanel: true });
		API.get('base/dashboard')
			.then(response => {
				let dashboard = { ...response.data };
				this.setState({ ...this.state, dashboard: dashboard });
			})
			.catch(error => {
				handleError(error, 'Ocorreu ua falha ao carregar o dashboard. Tente novamente mais tarde');
			})
			.then(() => {
				this.setState({ ...this.state, showLoadingPanel: false });
			});
	}

	render() {
		return (
			<div>
				<LoadPanel
					shadingColor={'rgba(0,0,0,0.4)'}
					position={{ of: '#root' }}
					visible={this.state.showLoadingPanel}
					showIndicator={true}
					shading={true}
					showPane={false}
				/>
				<Header />
				<SideBar />
				<div className="content-wrapper">
					<section class="content-header">
						<h1>
							Dashboard
							<small>Painel de Controle Gerencial</small>
						</h1>
						<ol class="breadcrumb">
							<li>
								<a href="#">
									<i class="fa fa-dashboard" /> Home
								</a>
							</li>
							<li class="active">Dashboard</li>
						</ol>
					</section>
					<section className="content">
						<div className="row">
							<div className="col-lg-3 col-xs-6">
								<div className="small-box bg-aqua">
									<div className="inner">
										<h3>{this.state.dashboard.countTransportLogisticRoute}</h3>
										<p>Total de Ordens de Carregamento</p>
									</div>
									<div className="icon">
										<i className="ion ion-bag" />
									</div>
									<Link
										to={{
											pathname: '/lancamento/nota-carregamento',
										}}
										className="small-box-footer"
									>
										Mais informações <i className="fa fa-arrow-circle-right" />
									</Link>
								</div>
							</div>

							<div className="col-lg-3 col-xs-6">
								<div className="small-box bg-orange">
									<div className="inner">
										<h3>{this.state.dashboard.countTranportLogisticRouteInit}</h3>

										<p>Aguardando</p>
									</div>
									<div className="icon">
										<i className="ion ion-load-a" />
									</div>
									<Link
										to={{
											pathname: '/lancamento/nota-carregamento',
											state: {
												statusId: 1,
											},
										}}
										className="small-box-footer"
									>
										Mais informações <i className="fa fa-arrow-circle-right" />
									</Link>
								</div>
							</div>

							<div className="col-lg-3 col-xs-6">
								<div className="small-box bg-yellow">
									<div className="inner">
										<h3>{this.state.dashboard.countTranportLogisticRouteInLoad}</h3>
										<p>Em carregamento</p>
									</div>
									<div className="icon">
										<i className="ion ion-android-cart" />
									</div>
									<Link
										to={{
											pathname: '/lancamento/nota-carregamento',
											state: {
												statusId: 2,
											},
										}}
										className="small-box-footer"
									>
										Mais informações <i className="fa fa-arrow-circle-right" />
									</Link>
								</div>
							</div>
							<div className="col-lg-3 col-xs-6">
								<div className="small-box bg-green">
									<div className="inner">
										<h3>{this.state.dashboard.countTranportLogisticRouteBilled}</h3>
										<p>Faturada</p>
									</div>
									<div className="icon">
										<i className="ion ion-stats-bars" />
									</div>
									<Link
										to={{
											pathname: '/lancamento/nota-carregamento',
											state: {
												statusId: 5,
											},
										}}
										className="small-box-footer"
									>
										Mais informações <i className="fa fa-arrow-circle-right" />
									</Link>
								</div>
							</div>
						</div>

						<div className="row">
							<section className="col-lg-12 connectedSortable">
								<div className="box box-solid  bg-green-gradient">
									<div className="box-header">
										<i className="fa fa-shopping-cart" />

										<h3 className="box-title">Ordens de Carregamento mais Recentes</h3>

										<div className="box-tools pull-right">
											<button
												type="button"
												className="btn bg-green btn-sm"
												data-widget="collapse"
											>
												<i className="fa fa-minus" />
											</button>
										</div>
									</div>
									<div className="box-body border-radius-none">
										<DataGrid
											height={140}
											dataSource={this.state.dashboard.trasnportLogisticRoute}
											focusedRowEnabled={false}
											showBorders={false}
											defaultColumns={[
												{ dataField: 'id', caption: 'Nº', width: '5%' },
												{
													dataField: 'transportedOn',
													dataType: 'date',
													format: 'dd/MM/yyyy HH:mm',
													caption: 'Data',
													width: '8%',
												},
												{ dataField: 'status', caption: 'Status', width: '10%' },
												{ dataField: 'sender', caption: 'Remetente' },
												{ dataField: 'recipient', caption: 'Destinatário' },
												{ dataField: 'shippingCompany', caption: 'Transportadora' },
												{ dataField: 'driver', caption: 'Motorista' },
												{ dataField: 'vehicle', caption: 'Caminhão', width: '8%' },
												{
													dataField: 'fiscalDocumentNumber',
													caption: 'Nota Fiscal',
													width: '7%',
												},
												{
													dataField: 'weight',
													caption: 'Peso',
													width: '7%',
													calculateCellValue: function(data) {
														var formatedValue = formatNumberDecimalPlaces(data.weight, 3);
														if (formatedValue) return formatedValue + ' Kg';
														else return '';
													},
												},
											]}
										/>
									</div>
								</div>
								<div className="box box-solid bg-light-blue-gradient">
									<div className="box-header">
										<div className="pull-right box-tools">
											<button
												type="button"
												className="btn btn-primary btn-sm pull-right"
												data-widget="collapse"
												data-toggle="tooltip"
												title="Collapse"
											>
												<i className="fa fa-minus" />
											</button>
										</div>

										<i className="fa fa-map-marker" />

										<h3 className="box-title">Últimos Acesso</h3>
									</div>
									<div className="box-body">
										<DataGrid
											height={130}
											dataSource={this.state.dashboard.userAccess}
											focusedRowEnabled={false}
											showBorders={false}
											defaultColumns={[
												{ dataField: 'userName', caption: 'Usuário' },
												{ dataField: 'email', caption: 'E-mail' },
												{
													dataField: 'onCreated',
													dataType: 'date',
													caption: 'Acesso',
													format: 'dd/MM/yyyy HH:mm',
												},
											]}
										/>
									</div>
								</div>
							</section>
						</div>
					</section>
				</div>
				<Footer />
			</div>
		);
	}
}

export default App;
